import { apiGateway } from "@/_old/services/api-gateway";
import { GetLocationsParams, GetLocationsResponse } from "../types";

const getLocations = async (
  params: GetLocationsParams,
  signal?: AbortSignal,
): Promise<GetLocationsResponse> => {
  const { data, total, count } = await apiGateway
    .get(`/api/spaces`, {
      params,
      signal,
    })
    .then((res) => {
      return {
        data: {
          cities: Object.values(res.data._embedded.cities).map((city: any) => ({
            id: city.cityname,
            name: city.cityname,
          })),
          spaces: res.data._embedded.spaces.map((space: any) => ({
            id: space.id,
            name: space.name,
            city: space.cityname,
          })),
        },
        total: res.data.total,
        count: res.data.count,
      };
    });

  return {
    data,
    total,
    count,
  } as unknown as GetLocationsResponse;
};

export { getLocations };
